import moment from "moment";
import "moment/locale/es";
import { useEffect, useMemo, useState } from "react";
import Barcode from "react-barcode";
import { useLocation, useNavigate } from "react-router-dom";
import {
    mostraAlertaError,
    mostraAlertaOk
} from "../../../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import Dropzone from "../../../../componentes/imagenes/Dropzone";
import Page from "../../../../componentes/plantilla/Page";
import {
    ImagenProducto,
    ProductosConLotesEditar,
    ProductosListar,
    ProductosTiposListar
} from "../../../../configuracion/apiUrls";
import {
    regexCODE,
    regexDescripcion,
    regexEntero,
    regexNombre,
} from "../../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { formatoMoneda } from "../../../../configuracion/validaciones";
moment.locale("es");
const MAX_IMAGENES = 5;

const EditarProducto = () => {
    const { token, setListaProductos, ActualizarLista, listaInventariosTipos } = useContextEmpleado();
    const location = useLocation();
    const navigate = useNavigate();
    const { datos } = location.state || {};

    const [formularioProducto, setFormularioProducto] = useState({
        id: null,
        nombre: "",
        descripcion: "",
        caracteristicas: "",
        tipo: "General",
        codigo: "000000000000",
        precio: 0,
        costo: 0,
        existencia: 0,
        puntoReorden: 0,
        impuesto: "",
        estado: "Disponible",
        productoTipoId: null,

        lotes: [{
            id: null,
            nombre_lote: "",
            fecha_ingreso: moment().format("YYYY-MM-DD"),
            costo: "0.00",
            precio: "0.00",
            utilidad: "0.00",
            estado: "Disponible",
            cantidad: "0",
            existencia: "0",
            enPedido: 0,
            loteprecios: [],
            loteinventarios: [],
        }],
    });
    const [imagenesEliminadas, setImagenesEliminadas] = useState([]);
    const [nuevasImagenes, setNuevasImagenes] = useState([]);
    const [imagenesPrevias, setImagenesPrevias] = useState([]);
    const [errorNombre, setErrorNombre] = useState(false);
    const [errorCodigo, setErrorCodigo] = useState(false);
    const [errorDescripcion, setErrorDescripcion] = useState(false);

    const [errorReorden, setErrorReorden] = useState(false);
    const [errorProductoTipoId, setErrorProductoTipoId] = useState(false);
    const [tiposProducto, setTiposProducto] = useState([]);

    const [erroresLote, setErroresLote] = useState({});
    const [erroresLotePrecio, setErroresLotePrecio] = useState({});
    const [erroresLoteInventario, setErroresLoteInventario] = useState({});
    const [nombreLotePrincipalState, setNombreLotePrincipalState] = useState("Lote #1");
    const [mostrarAgotados, setMostrarAgotados] = useState(false);

    const totalImagenes = imagenesPrevias.length + nuevasImagenes.length;
    const excedeLimite = totalImagenes > MAX_IMAGENES;

    const lotesAgotadosCount = useMemo(
        () => formularioProducto.lotes.filter((lote) => lote.estado === "Agotado").length,
        [formularioProducto.lotes]
    );

    const pageData = {
        titulo: {
            titulo: "Edición de Producto",
            url: "/app/admin/productos",
            tituloUrl: "Productos",
            nombreUrl: "edición",
        },
    };

    const impuestosOptions = [
        { value: "Exento", label: "Exento" },
        { value: "15%", label: "15%" },
        { value: "18%", label: "18%" },
    ];

    const tipoOptions = [
        { value: "General", label: "General" },
        { value: "Servicio", label: "Servicio" },
    ];

    useEffect(() => {
        if (datos) {

            const lotesDelApi = datos.lotes?.map(lote => ({
                id: lote.id,
                nombre_lote: lote.nombre_lote || `Lote ${lote.id}`,
                fecha_ingreso: moment(lote.fecha_ingreso).format("YYYY-MM-DD"),
                costo: String(lote.costo) || "0.00",
                precio: String(lote.precio) || "0.00",
                utilidad: String(lote.utilidad) || "0.00",
                estado: lote.estado || "Disponible",
                cantidad: String(lote.cantidad) || "0",
                existencia: String(lote.existencia) || "0",
                enPedido: lote.enPedido || 0,
                loteprecios: lote.loteprecios?.map(lp => ({
                    id: lp.id,
                    cantidad: String(lp.cantidad),
                    precio: String(lp.precio),
                    loteId: lote.id,
                    codigoLote: lote.nombre_lote,
                })) || [],
                loteinventarios: lote.loteinventarios?.map(li => ({
                    id: li.id,
                    existencia: String(li.existencia) || "0",
                    estado: li.estado || "Activo",
                    inventarioTipoId: li.inventarioTipo?.id || "",
                    loteId: lote.id,
                    codigoLote: lote.nombre_lote,
                })) || [],
            })) || [];

            const lotesAUsar = lotesDelApi.length > 0 ? lotesDelApi : [{
                id: null,
                nombre_lote: "Lote Nuevo",
                fecha_ingreso: moment().format("YYYY-MM-DD"),
                costo: "0.00",
                precio: "0.00",
                utilidad: "0.00",
                estado: "Disponible",
                cantidad: "0",
                existencia: "0",
                enPedido: 0,
                loteprecios: [],
                loteinventarios: [],
            }];

            const existenciaTotalProducto = lotesAUsar.reduce((sum, lote) => sum + (parseInt(lote.existencia) || 0), 0);

            const primerLoteDisponible = lotesAUsar.find(lote => lote.estado === "Disponible");
            const lotePrincipalParaCostoPrecio = primerLoteDisponible || lotesAUsar[0];

            let costoBase = datos.costo || "0";
            let precioBase = datos.precio || "0";
            let nombreLote = "Lote #1";

            if (lotePrincipalParaCostoPrecio) {
                costoBase = String(lotePrincipalParaCostoPrecio.costo) || "0.00";
                precioBase = String(lotePrincipalParaCostoPrecio.precio) || "0.00";
                const loteIndex = lotesAUsar.indexOf(lotePrincipalParaCostoPrecio);
                nombreLote = lotePrincipalParaCostoPrecio.nombre_lote || `Lote #${loteIndex + 1}`;
            }

            setNombreLotePrincipalState(nombreLote);


            setFormularioProducto(prev => ({
                ...prev,
                id: datos.id,
                nombre: datos.nombre || "",
                descripcion: datos.descripcion || "",
                caracteristicas: datos.caracteristicas || "",
                tipo: datos.tipo || "General",
                codigo: datos.codigo || "000000000000",
                precio: precioBase,
                costo: costoBase,
                existencia: existenciaTotalProducto,
                puntoReorden: datos.puntoReorden || 0,
                impuesto: datos.impuesto || "15%",
                estado: datos.estado === "Disponible" ? "Disponible" : "Agotado",
                productoTipoId: datos.productoTipoId || null,

                lotes: lotesAUsar,
            }));

            setImagenesEliminadas([]);
            setNuevasImagenes([]);
            if (datos.productoImagens) {
                setImagenesPrevias(
                    datos.productoImagens.map(img => ({
                        id: img.id,
                        url: `${ImagenProducto}${img.imagen}`,
                        imagen: img.imagen
                    }))
                );
            }
        } else {
            setFormularioProducto(prev => ({
                ...prev,
                lotes: [{
                    id: null,
                    nombre_lote: "Lote Nuevo",
                    fecha_ingreso: moment().format("YYYY-MM-DD"),
                    costo: "0.00",
                    precio: "0.00",
                    utilidad: "0.00",
                    estado: "Disponible",
                    cantidad: "0",
                    existencia: "0",
                    enPedido: 0,
                    loteprecios: [],
                    loteinventarios: [],
                }],
            }));
        }
    }, [datos]);

    useEffect(() => {
        setErrorNombre(!regexNombre.test(formularioProducto.nombre));
        setErrorDescripcion(!regexDescripcion.test(formularioProducto.descripcion));
        setErrorProductoTipoId(!regexEntero.test(formularioProducto.productoTipoId));
        setErrorCodigo(!regexCODE.test(formularioProducto.codigo));
        setErrorReorden(!regexEntero.test(formularioProducto.puntoReorden));

        const newErroresLote = {};
        const newErroresLotePrecio = {};
        const newErroresLoteInventario = {};

        let totalExistenciaProducto = 0;
        let primerCosto = "0.00";
        let primerPrecio = "0.00";
        let nombreLotePrincipal = "Lote #1";

        formularioProducto.lotes.forEach((lote, loteIndex) => {
            const nombreLote = lote.nombre_lote || `Lote #${loteIndex + 1}`;

            const precioString = lote.precio;
            const costoString = lote.costo;
            const cantidadString = lote.cantidad;
            const existenciaString = lote.existencia;

            const isCostoEmpty = costoString === "" || costoString === null || costoString === undefined;
            const isPrecioEmpty = precioString === "" || precioString === null || precioString === undefined;

            const costo = parseFloat(costoString);
            const precio = parseFloat(precioString);

            const isCostoInvalid = isCostoEmpty || isNaN(costo) || costo < 0;
            const isPrecioInvalid = isPrecioEmpty || isNaN(precio) || precio < 0;

            if (!lote.fecha_ingreso) {
                newErroresLote[`${loteIndex}-fecha_ingreso`] = `La fecha de ingreso del ${nombreLote} es requerida.`;
            }
            if (isCostoInvalid) {
                newErroresLote[`${loteIndex}-costo`] = isCostoEmpty ? `El costo del ${nombreLote} es requerido.` : `El costo del ${nombreLote} debe ser un número positivo.`;
            }
            if (isPrecioInvalid) {
                newErroresLote[`${loteIndex}-precio`] = isPrecioEmpty ? `El precio del ${nombreLote} es requerido.` : `El precio del ${nombreLote} debe ser un número positivo.`;
            }

            const isCantidadEmpty = cantidadString === "" || cantidadString === null || cantidadString === undefined;
            const isExistenciaEmpty = existenciaString === "" || existenciaString === null || existenciaString === undefined;

            const isCantidadInvalid = isCantidadEmpty || !regexEntero.test(cantidadString) || parseInt(cantidadString) < 0;
            const isExistenciaInvalid = isExistenciaEmpty || !regexEntero.test(existenciaString) || parseInt(existenciaString) < 0;

            if (isCantidadInvalid) {
                newErroresLote[`${loteIndex}-cantidad`] = isCantidadEmpty ? `La cantidad inicial del ${nombreLote} es requerida.` : `La cantidad inicial del ${nombreLote} debe ser un número entero y positivo.`;
            }
            if (isExistenciaInvalid) {
                newErroresLote[`${loteIndex}-existencia`] = isExistenciaEmpty ? `La existencia actual del ${nombreLote} es requerida.` : `La existencia actual del ${nombreLote} debe ser un número entero mayor o igual a 0.`;
            }

            totalExistenciaProducto += parseInt(existenciaString) || 0;

            const erroresVolumen = (lote.loteprecios || []).some((item, index) => {
                const cantidad = parseInt(item.cantidad);
                const precioVol = parseFloat(item.precio);

                const cantidadInvalida = (!Number.isInteger(cantidad) || cantidad < 1 || item.cantidad === "");
                const precioInvalido = (isNaN(precioVol) || precioVol < 0 || item.precio === "");

                if (cantidadInvalida || precioInvalido) {
                    newErroresLotePrecio[`${loteIndex}-${index}`] = `El precio por volumen ${index + 1} del ${nombreLote} tiene datos inválidos.`;
                    return true;
                }
                return false;
            });
            if (erroresVolumen) {
                newErroresLotePrecio[`lote-${loteIndex}`] = true;
            }

            const existenciaTotalLote = parseInt(existenciaString) || 0;
            const totalAsignado = (lote.loteinventarios || []).reduce((sum, item) => {
                return sum + (parseInt(item.existencia) || 0);
            }, 0);

            const totalAsignacionExceeded = totalAsignado > existenciaTotalLote;

            const errorInRowsInventario = (lote.loteinventarios || []).some((item, index) => {
                const existencia = parseInt(item.existencia);
                const isExistenciaRowInvalid = existencia < 0 || !Number.isInteger(existencia) || item.existencia === "";
                const isTipoIdInvalid = !item.inventarioTipoId;

                if (isExistenciaRowInvalid || isTipoIdInvalid) {
                    newErroresLoteInventario[`${loteIndex}-${index}`] = `La asignación ${index + 1} del ${nombreLote} tiene existencia o tipo inválido.`;
                    return true;
                }
                return false;
            });

            if (errorInRowsInventario || totalAsignacionExceeded) {
                if (totalAsignacionExceeded) {
                    newErroresLoteInventario[`lote-exceso-${loteIndex}`] = `El ${nombreLote} tiene ${totalAsignado} unidades asignadas, excediendo la existencia actual de ${existenciaTotalLote}.`;
                }
                newErroresLoteInventario[`lote-${loteIndex}`] = true;
            }
        });

        const primerLoteDisponible = formularioProducto.lotes.find(lote => lote.estado === "Disponible");

        const lotePrincipalParaCostoPrecio = primerLoteDisponible || formularioProducto.lotes[0];

        if (lotePrincipalParaCostoPrecio) {
            const costo = parseFloat(lotePrincipalParaCostoPrecio.costo);
            const precio = parseFloat(lotePrincipalParaCostoPrecio.precio);

            const costoParaCalculo = isNaN(costo) ? 0 : costo;
            const precioParaCalculo = isNaN(precio) ? 0 : precio;

            primerCosto = String(costoParaCalculo.toFixed(2));
            primerPrecio = String(precioParaCalculo.toFixed(2));

            const loteIndex = formularioProducto.lotes.indexOf(lotePrincipalParaCostoPrecio);
            nombreLotePrincipal = lotePrincipalParaCostoPrecio.nombre_lote || `Lote #${loteIndex + 1}`;
        }


        setErroresLote(newErroresLote);
        setErroresLotePrecio(newErroresLotePrecio);
        setErroresLoteInventario(newErroresLoteInventario);

        setFormularioProducto(prev => {
            let shouldUpdate = false;

            const newLotes = prev.lotes.map((lote) => {
                const precio = parseFloat(lote.precio) || 0;
                const costo = parseFloat(lote.costo) || 0;
                const calculatedUtilidad = (precio - costo).toFixed(2);

                if (calculatedUtilidad !== lote.utilidad) {
                    shouldUpdate = true;
                    return { ...lote, utilidad: calculatedUtilidad };
                }
                return lote;
            });

            const newForm = {
                ...prev,
                existencia: totalExistenciaProducto,
                lotes: newLotes,
            };

            if (prev.costo !== primerCosto) {
                newForm.costo = primerCosto;
            }
            if (prev.precio !== primerPrecio) {
                newForm.precio = primerPrecio;
            }

            if (shouldUpdate || prev.existencia !== totalExistenciaProducto || prev.costo !== primerCosto || prev.precio !== primerPrecio) {
                return newForm;
            }
            return prev;
        });

        if (nombreLotePrincipalState !== nombreLotePrincipal) {
            setNombreLotePrincipalState(nombreLotePrincipal);
        }


    }, [formularioProducto.nombre, formularioProducto.descripcion, formularioProducto.productoTipoId, formularioProducto.codigo, formularioProducto.puntoReorden, formularioProducto.lotes, nombreLotePrincipalState]);

    useEffect(() => {
        const fetchTiposProducto = async () => {
            try {
                const response = await AxiosPrivado.get(ProductosTiposListar);
                setTiposProducto(response.data);
            } catch (error) {
                console.error("Error fetching tipos de producto:", error);
            }
        };
        fetchTiposProducto();
    }, []);

    const manejadorProducto = (event) => {
        const { name, value, type, checked } = event.target;
        setFormularioProducto(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? "Disponible" : "Agotado") : value,
        }));
    };

    const manejadorLoteCampo = (e, loteIndex) => {
        const { name, value } = e.target;
        const newLotes = [...formularioProducto.lotes];

        newLotes[loteIndex] = {
            ...newLotes[loteIndex],
            [name]: value,
        };

        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));

        setErroresLote(prev => {
            const newErrors = { ...prev };
            delete newErrors[`${loteIndex}-${name}`];

            const hasOtherErrorsInLote = Object.keys(newErrors).some(key => key.startsWith(`${loteIndex}-`));
            if (!hasOtherErrorsInLote) {
                delete newErrors[`lote-${loteIndex}`];
            }
            return newErrors;
        });
    };

    const manejadorPrimerLoteCostoPrecio = (e, name) => {
        const { value } = e.target;
        manejadorLoteCampo({ target: { name, value } }, 0);
    };


    const handleEliminarImagen = (idImg) => {
        const imagenAEliminar = imagenesPrevias.find((img) => img.id === idImg);
        if (imagenAEliminar) {
            setImagenesEliminadas(prev => [...prev, imagenAEliminar.id]);
            setImagenesPrevias(prev => prev.filter((img) => img.id !== idImg));
        }
    };

    const agregarLotePrecio = (loteIndex) => {
        const newLotes = [...formularioProducto.lotes];

        newLotes[loteIndex] = {
            ...newLotes[loteIndex],
            loteprecios: [
                ...(newLotes[loteIndex].loteprecios || []),
                { cantidad: "1", precio: "0.00" },
            ],
        };
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLotePrecio({});
    };

    const eliminarLotePrecio = (loteIndex, precioIndex) => {
        const newLotes = [...formularioProducto.lotes];

        newLotes[loteIndex].loteprecios = newLotes[loteIndex].loteprecios.filter(
            (_, i) => i !== precioIndex
        );
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLotePrecio({});
    };

    const handleLotePrecioChange = (loteIndex, precioIndex, name, value) => {
        const newLotes = [...formularioProducto.lotes];
        const newLoteprecios = [...(newLotes[loteIndex].loteprecios || [])];

        newLoteprecios[precioIndex] = {
            ...newLoteprecios[precioIndex],
            [name]: value,
        };

        newLotes[loteIndex].loteprecios = newLoteprecios;
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLotePrecio(prev => {
            const newErrors = { ...prev };
            delete newErrors[`${loteIndex}-${precioIndex}`];
            const hasOtherErrorsInLote = Object.keys(newErrors).some(key => key.startsWith(`${loteIndex}-`));
            if (!hasOtherErrorsInLote) {
                delete newErrors[`lote-${loteIndex}`];
            }
            return newErrors;
        });
    };

    const agregarLoteInventario = (loteIndex) => {
        const newLotes = [...formularioProducto.lotes];

        newLotes[loteIndex] = {
            ...newLotes[loteIndex],
            loteinventarios: [
                ...(newLotes[loteIndex].loteinventarios || []),
                { existencia: "0", inventarioTipoId: "", estado: "Activo" },
            ],
        };
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLoteInventario({});
    };

    const eliminarLoteInventario = (loteIndex, inventarioIndex) => {
        const newLotes = [...formularioProducto.lotes];

        newLotes[loteIndex].loteinventarios = newLotes[loteIndex].loteinventarios.filter(
            (_, i) => i !== inventarioIndex
        );
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLoteInventario({});
    };

    const handleLoteInventarioChange = (loteIndex, inventarioIndex, name, value) => {
        const newLotes = [...formularioProducto.lotes];
        const newLoteinventarios = [...(newLotes[loteIndex].loteinventarios || [])];

        const finalValue = name === 'existencia' ? (value === "" ? "" : String(value)) : value;

        newLoteinventarios[inventarioIndex] = {
            ...newLoteinventarios[inventarioIndex],
            [name]: finalValue,
        };

        newLotes[loteIndex].loteinventarios = newLoteinventarios;
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));

        setErroresLoteInventario(prev => {
            const newErrors = { ...prev };
            delete newErrors[`${loteIndex}-${inventarioIndex}`];

            const lote = newLotes[loteIndex];
            const existenciaTotalLote = parseInt(lote.existencia) || 0;
            const totalAsignado = newLoteinventarios.reduce((sum, item) => sum + (parseInt(item.existencia) || 0), 0);

            if (totalAsignado <= existenciaTotalLote) {
                delete newErrors[`lote-exceso-${loteIndex}`];
            }

            const hasErrorsInLote = Object.keys(newErrors).some(key => key.startsWith(`${loteIndex}-`));
            if (!hasErrorsInLote) {
                delete newErrors[`lote-${loteIndex}`];
            }

            return newErrors;
        });
    };

    const isFormularioInvalido = () => {
        const erroresProducto = errorNombre || errorDescripcion || errorProductoTipoId || errorCodigo || errorReorden;

        const erroresLotesGenerales = Object.keys(erroresLote).length > 0;

        const erroresLotesPrecios = Object.keys(erroresLotePrecio).length > 0;
        const erroresLotesInventario = Object.keys(erroresLoteInventario).length > 0;

        return erroresProducto || erroresLotesGenerales || erroresLotesPrecios || erroresLotesInventario;
    }

    const editarProducto = async () => {
        if (excedeLimite) {
            mostraAlertaError(`No puedes tener más de ${MAX_IMAGENES} imágenes.`);
            return;
        }

        if (isFormularioInvalido()) {
            mostraAlertaError("Existen errores en los datos del formulario. Por favor, corríjalos (Verifique las secciones de Producto y Lotes).");
            return;
        }

        try {
            const formData = new FormData();
            nuevasImagenes.forEach((file) => {
                formData.append("imagenes", file);
            });
            formData.append("imagenesEliminadas", JSON.stringify(imagenesEliminadas.map(img => img.id || img)));

            formData.append("id", formularioProducto.id);
            formData.append("nombre", formularioProducto.nombre);
            formData.append("descripcion", formularioProducto.descripcion);
            formData.append("caracteristicas", formularioProducto.caracteristicas || "");
            formData.append("tipo", formularioProducto.tipo);
            formData.append("codigo", formularioProducto.codigo);
            formData.append("precio", formularioProducto.precio);
            formData.append("costo", formularioProducto.costo);
            formData.append("existencia", formularioProducto.existencia);
            formData.append("puntoReorden", formularioProducto.puntoReorden);
            formData.append("impuesto", formularioProducto.impuesto);
            formData.append("estado", formularioProducto.estado);
            formData.append("productoTipoId", formularioProducto.productoTipoId);

            const lotesArray = formularioProducto.lotes.map(lote => ({
                id: lote.id,
                nombre_lote: lote.nombre_lote,
                fecha_ingreso: moment(lote.fecha_ingreso).format("YYYY-MM-DD"),
                costo: lote.costo,
                precio: lote.precio,
                utilidad: lote.utilidad,
                estado: lote.estado,
                cantidad: lote.cantidad,
                existencia: lote.existencia,
                enPedido: lote.enPedido || 0,
            }));
            formData.append("lotes", JSON.stringify(lotesArray));

            const lotesPreciosPayload = [];
            formularioProducto.lotes.forEach((lote) => {
                (lote.loteprecios || []).forEach((item) => {
                    lotesPreciosPayload.push({
                        id: item.id || null,
                        cantidad: item.cantidad,
                        precio: item.precio,
                        loteId: lote.id,
                    });
                });
            });
            formData.append("lotesPrecios", JSON.stringify(lotesPreciosPayload));


            const lotesInventarioPayload = [];
            formularioProducto.lotes.forEach((lote) => {
                (lote.loteinventarios || []).forEach((item) => {
                    lotesInventarioPayload.push({
                        id: item.id || null,
                        existencia: item.existencia,
                        inventarioTipoId: item.inventarioTipoId,
                        estado: item.estado,
                        loteId: lote.id,
                    });
                });
            });
            formData.append("lotesInventario", JSON.stringify(lotesInventarioPayload));


            await AxiosImagen.put(`${ProductosConLotesEditar}${formularioProducto.id}`, formData);

            mostraAlertaOk("Producto actualizado correctamente");
            ActualizarLista(ProductosListar, setListaProductos);
            navigate("/app/admin/productos/gestionar");

        } catch (er) {
            console.error("Error al actualizar:", er);
            ErroresPeticion(er);
        }
    };

    const BotonEditar = () => (
        <button type="button" className="btn btn-warning" onClick={editarProducto} disabled={excedeLimite || isFormularioInvalido()}>
            Guardar <i className="fas fa-save ms-2" />
        </button>
    );

    const primerLote = formularioProducto.lotes[0];
    const errorPrimerLoteCosto = erroresLote['0-costo'];
    const errorPrimerLotePrecio = erroresLote['0-precio'];

    return (
        <Page datos={pageData}>
            <Card titulo="Editar producto" pie={<BotonEditar />}>
                <h5 className="mt-2 mb-3 text-primary">Detalles del Producto</h5>
                <hr className="mb-4" />

                <div className="row mb-3">
                    <div className="col-md-4">
                        <label>Código</label>
                        <div className="form-group">
                            <input type="text" className={`form-control ${errorCodigo ? "is-invalid" : ""}`} name="codigo" placeholder="Código de barras" value={formularioProducto.codigo} onChange={manejadorProducto} />
                            {errorCodigo && (<div className="invalid-feedback">El código puede usar números y letras.</div>)}
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="form-group">
                            {errorCodigo ? <p className="text-danger">Ingrese un código válido</p> : <Barcode value={formularioProducto.codigo} format="CODE128" width={2} height={50} displayValue={true} />}
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <label>Nombre</label>
                        <div className="form-group">
                            <input type="text" className={`form-control ${errorNombre ? "is-invalid" : ""}`} name="nombre" placeholder="Nombre del producto" value={formularioProducto.nombre} onChange={manejadorProducto} />
                            {errorNombre && (<div className="invalid-feedback">El nombre debe tener entre 3 y 50 caracteres.</div>)}
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <label>Descripción</label>
                        <div className="form-group">
                            <textarea rows="3" className={`form-control ${errorDescripcion ? "is-invalid" : ""}`} name="descripcion" placeholder="Escribe la descripción" value={formularioProducto.descripcion} onChange={manejadorProducto} />
                            {errorDescripcion && (<div className="invalid-feedback">La descripción debe tener entre 9 y 150 caracteres.</div>)}
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <label>Características</label>
                        <div className="form-group">
                            <textarea
                                rows="3"
                                className="form-control"
                                name="caracteristicas"
                                placeholder="Característica 1&#10;Característica 2&#10;Característica 3"
                                value={formularioProducto.caracteristicas}
                                onChange={manejadorProducto}
                            />
                            <small className="form-text text-muted">
                                Ingrese cada característica en una nueva línea.
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6 col-sm-12">
                        <label>Costo</label>
                        <div className="form-group">
                            <input
                                type="number"
                                step="0.01"
                                className={`form-control ${errorPrimerLoteCosto ? "is-invalid" : ""}`}
                                name="costo"
                                placeholder="Costo unitario"
                                value={formularioProducto.costo}
                                onChange={(e) => manejadorPrimerLoteCostoPrecio(e, "costo")}
                            />
                            {errorPrimerLoteCosto && (
                                <div className="invalid-feedback">
                                    {errorPrimerLoteCosto}
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="col-md-6 col-sm-12">
                        <label>Precio</label>
                        <div className="form-group">
                            <input
                                type="number"
                                step="0.01"
                                className={`form-control ${errorPrimerLotePrecio ? "is-invalid" : ""}`}
                                name="precio"
                                placeholder="Precio unitario de venta"
                                value={formularioProducto.precio}
                                onChange={(e) => manejadorPrimerLoteCostoPrecio(e, "precio")}
                            />
                            {errorPrimerLotePrecio && (
                                <div className="invalid-feedback">
                                    {errorPrimerLotePrecio}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6 col-sm-12">
                        <label>Existencia Total del Producto</label>
                        <div className="form-group">
                            <input
                                type="number"
                                step="1"
                                className="form-control"
                                name="existencia"
                                value={formularioProducto.existencia}
                                readOnly
                                disabled
                            />
                            <small className="form-text text-muted">
                                Suma de existencias de todos los lotes.
                            </small>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <label>Punto Reorden</label>
                        <div className="form-group">
                            <input type="number" step="1" className={`form-control ${errorReorden ? "is-invalid" : ""}`} name="puntoReorden" placeholder="Reorden" value={formularioProducto.puntoReorden} onChange={manejadorProducto} />
                            {errorReorden && <div className="invalid-feedback">Ingrese un valor válido.</div>}
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-4 col-sm-12">
                        <label>Impuesto</label>
                        <div className="form-group">
                            <select className="form-control" name="impuesto" value={formularioProducto.impuesto} onChange={manejadorProducto}>
                                <option value="">Seleccione impuesto</option>
                                {impuestosOptions.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <label>Tipo producto</label>
                        <div className="form-group">
                            <select className="form-control" name="tipo" value={formularioProducto.tipo} onChange={manejadorProducto}>
                                <option value="">Seleccione tipo</option>
                                {tipoOptions.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <label>Categoría</label>
                        <div className="form-group">
                            <select className={`form-control ${errorProductoTipoId ? "is-invalid" : ""}`} name="productoTipoId" value={formularioProducto.productoTipoId || ""} onChange={manejadorProducto}>
                                <option value="">Seleccione categoría</option>
                                {tiposProducto.map(t => (<option key={t.id} value={t.id}>{t.nombre}</option>))}
                            </select>
                            {errorProductoTipoId && <div className="invalid-feedback">Debe seleccionar un tipo.</div>}
                        </div>
                    </div>
                </div>

                <div className="row mt-3 my-4">
                    <div className="col-sm-2">
                        <label>Estado</label>
                        <div className="custom-control custom-switch">
                            <input type="checkbox" className="custom-control-input" id="switchEstado" name="estado" checked={formularioProducto.estado === "Disponible"} onChange={manejadorProducto} />
                            <label className="custom-control-label" htmlFor="switchEstado">{formularioProducto.estado}</label>
                        </div>
                    </div>
                </div>
                <div className="card border-secondary mb-4 shadow-sm">
                    <div className="card-header bg-secondary text-white">
                        <h5 className="mb-0">Imágenes del producto</h5>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-12 d-flex flex-wrap gap-2">
                                {imagenesPrevias.map(img => (
                                    <div key={img.id} className="position-relative" style={{ width: "100px" }}>
                                        <img src={img.url} className="img-thumbnail" alt="Previa" />
                                        <button type="button" className="btn btn-danger btn-sm position-absolute" style={{ top: "5px", right: "5px", borderRadius: "50%" }} onClick={() => handleEliminarImagen(img.id)}>✖</button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12">
                                <Dropzone max={MAX_IMAGENES - imagenesPrevias.length} files={nuevasImagenes} setFiles={setNuevasImagenes} />
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                            <p className="mb-0 text-muted">Tienes {totalImagenes} de {MAX_IMAGENES} imágenes.</p>
                            {excedeLimite && <p className="mb-0 text-danger">Ha excedido el límite de imágenes.</p>}
                        </div>
                    </div>
                </div>

                <h5 className="mt-5 mb-3 text-primary">Gestión de Lotes</h5>
                <hr className="mb-4" />
                <div className="row align-items-center mb-4">
                    <div className="col-12 col-md-8">
                        <div className="form-check form-switch d-flex align-items-center gap-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="switchMostrarAgotados"
                                checked={mostrarAgotados}
                                onChange={(e) => setMostrarAgotados(e.target.checked)}
                            />
                            <label className="form-check-label mb-0" htmlFor="switchMostrarAgotados">
                                Mostrar lotes agotados
                            </label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 text-md-end mt-3 mt-md-0">
                        <small className="text-secondary">
                            Total lotes: <strong>{formularioProducto.lotes.length}</strong> • Agotados: <strong>{lotesAgotadosCount}</strong>
                        </small>
                    </div>
                </div>
                {lotesAgotadosCount > 0 && !mostrarAgotados && (
                    <div className="alert alert-info py-2">
                        <i className="fas fa-eye-slash me-2"></i>
                        Se están ocultando <strong>{lotesAgotadosCount}</strong> lote(s) agotado(s). Activa el switch para visualizarlos.
                    </div>
                )}
                {Object.keys(erroresLote).length > 0 && (
                    <div className="alert alert-danger" role="alert">
                        <h6 className="alert-heading"><i className="fas fa-exclamation-triangle me-2"></i> Errores en Lotes (Detalles Generales)</h6>
                        <ul className="mb-0">
                            {Object.keys(erroresLote).map((key) => (
                                <li key={key}>{erroresLote[key]}</li>
                            ))}
                        </ul>
                    </div>
                )}

                {formularioProducto.lotes.filter((lote) => mostrarAgotados || lote.estado !== "Agotado").length === 0 && (
                    <div className="alert alert-warning py-2">
                        <i className="fas fa-info-circle me-2"></i>
                        No hay lotes visibles actualmente. Activa el switch para ver los lotes agotados.
                    </div>
                )}

                {formularioProducto.lotes.map((lote, loteIndex) => {
                    if (!mostrarAgotados && lote.estado === "Agotado") {
                        return null;
                    }
                    const nombreLoteDisplay = lote.nombre_lote || `Lote #${loteIndex + 1}`;
                    const existenciaTotal = parseInt(lote.existencia) || 0;
                    const totalAsignado = (lote.loteinventarios || []).reduce((sum, item) => sum + (parseInt(item.existencia) || 0), 0);
                    const existenciaDisponible = existenciaTotal - totalAsignado;

                    const loteTieneErrores = erroresLote[`lote-${loteIndex}`] || erroresLotePrecio[`lote-${loteIndex}`] || erroresLoteInventario[`lote-${loteIndex}`] || erroresLoteInventario[`lote-exceso-${loteIndex}`] || Object.keys(erroresLote).some(key => key.startsWith(`${loteIndex}-`));
                    const claseCard = loteTieneErrores ? "border-danger" : "border-primary";

                    const errorGeneralLoteInventario = erroresLoteInventario[`lote-exceso-${loteIndex}`];
                    const hayErroresEnLotePrecios = erroresLotePrecio[`lote-${loteIndex}`];

                    return (
                        <div key={loteIndex} className={`card ${claseCard} mb-4 shadow-sm`}>
                            <div className={`card-header ${loteTieneErrores ? 'bg-danger text-white' : 'bg-primary text-white'} d-flex justify-content-between align-items-center`}>
                                <h6 className="mb-0">Detalles del Lote #{loteIndex + 1} ({nombreLoteDisplay})</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`nombreLote-${loteIndex}`} className="form-label">Nombre</label>
                                            <input
                                                type="text"
                                                className={`form-control ${erroresLote[`${loteIndex}-nombre_lote`] ? "is-invalid" : ""}`}
                                                id={`nombreLote-${loteIndex}`}
                                                placeholder="Ej. Lote A1"
                                                name="nombre_lote"
                                                value={lote.nombre_lote}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-nombre_lote`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-nombre_lote`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`fechaIngresoLote-${loteIndex}`} className="form-label">Fecha de ingreso</label>
                                            <input
                                                type="text"
                                                className={`form-control ${erroresLote[`${loteIndex}-fecha_ingreso`] ? "is-invalid" : ""}`}
                                                id={`fechaIngresoLote-${loteIndex}`}
                                                value={lote.fecha_ingreso}
                                                readOnly
                                            />
                                            {erroresLote[`${loteIndex}-fecha_ingreso`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-fecha_ingreso`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`costoLote-${loteIndex}`} className="form-label">Costo</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control ${erroresLote[`${loteIndex}-costo`] ? "is-invalid" : ""}`}
                                                id={`costoLote-${loteIndex}`}
                                                placeholder="Costo total del lote"
                                                name="costo"
                                                value={lote.costo}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-costo`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-costo`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`precioLote-${loteIndex}`} className="form-label">Precio</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control ${erroresLote[`${loteIndex}-precio`] ? "is-invalid" : ""}`}
                                                id={`precioLote-${loteIndex}`}
                                                placeholder="Precio de venta del lote"
                                                name="precio"
                                                value={lote.precio}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-precio`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-precio`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`utilidadLote-${loteIndex}`} className="form-label">Utilidad</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className="form-control"
                                                id={`utilidadLote-${loteIndex}`}
                                                placeholder="Utilidad calculada"
                                                name="utilidad"
                                                value={lote.utilidad}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`cantidadLote-${loteIndex}`} className="form-label">Cantidad (Ingreso inicial)</label>
                                            <input
                                                type="number"
                                                step="1"
                                                className={`form-control ${erroresLote[`${loteIndex}-cantidad`] ? "is-invalid" : ""}`}
                                                id={`cantidadLote-${loteIndex}`}
                                                name="cantidad"
                                                value={lote.cantidad}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-cantidad`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-cantidad`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`existenciaLote-${loteIndex}`} className="form-label">Existencia Actual</label>
                                            <input
                                                type="number"
                                                step="1"
                                                className={`form-control ${erroresLote[`${loteIndex}-existencia`] ? "is-invalid" : ""}`}
                                                id={`existenciaLote-${loteIndex}`}
                                                name="existencia"
                                                value={lote.existencia}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-existencia`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-existencia`]}</div>
                                            )}
                                            <small className="form-text text-muted">
                                                Unidades disponibles para venta/asignación.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor={`estadoLote-${loteIndex}`} className="form-label">Estado</label>
                                            <div className="form-check form-switch mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={`estadoLoteSwitch-${loteIndex}`}
                                                    name="estado"
                                                    checked={lote.estado === "Disponible"}
                                                    onChange={(event) => {
                                                        const newLotes = [...formularioProducto.lotes];
                                                        newLotes[loteIndex] = {
                                                            ...newLotes[loteIndex],
                                                            estado: event.target.checked ? "Disponible" : "Agotado",
                                                        };
                                                        setFormularioProducto((prev) => ({
                                                            ...prev,
                                                            lotes: newLotes,
                                                        }));
                                                    }}
                                                />
                                                <label className="custom-control-label" htmlFor={`estadoLoteSwitch-${loteIndex}`}>
                                                    {lote.estado === "Disponible" ? "Disponible" : "Agotado"}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5 className="mt-4 pb-2 border-bottom text-muted">
                                    <i className="fas fa-money-bill-wave me-2 mx-2"></i> Precios por mayoreo ({nombreLoteDisplay})
                                </h5>
                                <button
                                    className={`btn btn-sm ${hayErroresEnLotePrecios ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                                    onClick={() => agregarLotePrecio(loteIndex)}
                                >
                                    <i className="fas fa-plus me-2"></i> Agregar nivel de precio
                                </button>
                                <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                                    <i className="fas fa-tags me-3 fa-lg text-muted"></i>
                                    <p className="mb-0">
                                        <strong>Niveles de precio por volumen definidos:</strong>&nbsp;
                                        <span className={`badge ${hayErroresEnLotePrecios ? 'bg-danger' : 'bg-dark'}`}>
                                            {lote.loteprecios?.length || 0}
                                            &nbsp;niveles
                                        </span>
                                    </p>
                                </div>
                                {hayErroresEnLotePrecios && (
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fas fa-exclamation-circle me-2"></i>
                                        Hay errores en los precios por mayoreo. Revise Cantidad Mínima (debe ser &ge; 1 y entero) y Precio (&ge; 0).
                                    </div>
                                )}
                                {lote.loteprecios && lote.loteprecios.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm align-middle">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th style={{ width: '30%' }}>Cantidad Mínima</th>
                                                    <th style={{ width: '40%' }}>Precio por Unidad</th>
                                                    <th style={{ width: '15%' }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lote.loteprecios.map((item, precioIndex) => {
                                                    const esErrorFila = erroresLotePrecio[`${loteIndex}-${precioIndex}`];

                                                    return (
                                                        <tr key={precioIndex} className={esErrorFila ? 'table-warning' : ''}>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    step="1"
                                                                    className={`form-control form-control-sm ${esErrorFila ? "is-invalid" : ""}`}
                                                                    min="1"
                                                                    value={item.cantidad}
                                                                    onChange={(e) =>
                                                                        handleLotePrecioChange(loteIndex, precioIndex, "cantidad", e.target.value)
                                                                    }
                                                                />
                                                                {esErrorFila && (
                                                                    <div className="invalid-feedback">
                                                                        Cantidad inválida.
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    className={`form-control form-control-sm ${esErrorFila ? "is-invalid" : ""}`}
                                                                    value={item.precio}
                                                                    onChange={(e) =>
                                                                        handleLotePrecioChange(loteIndex, precioIndex, "precio", e.target.value)
                                                                    }
                                                                />
                                                                {esErrorFila && (
                                                                    <div className="invalid-feedback">
                                                                        Precio inválido.
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light text-danger"
                                                                    onClick={() => eliminarLotePrecio(loteIndex, precioIndex)}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-light border text-muted">
                                        <i className="fas fa-info-circle me-2"></i>
                                        No hay precios por volumen definidos.
                                    </div>
                                )}


                                <h5 className="mt-4 pb-2 border-bottom text-muted">
                                    <i className="fas fa-boxes me-2 mx-2"></i> Asignación de inventario del lote ({nombreLoteDisplay})
                                </h5>
                                <button
                                    className={`btn btn-sm ${errorGeneralLoteInventario || hayErroresEnLotePrecios ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                                    onClick={() => agregarLoteInventario(loteIndex)}
                                >
                                    <i className="fas fa-plus me-2"></i> Asignar ubicación
                                </button>

                                <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                                    <i className="fas fa-box-open me-3 fa-lg text-muted"></i>
                                    <p className="mb-0">
                                        <strong>Existencia total del lote disponible para asignación:</strong>&nbsp;
                                        <span className={`badge ${existenciaDisponible >= 0 ? 'bg-dark' : 'bg-danger'}`}>
                                            {existenciaDisponible}
                                            &nbsp;unidades
                                        </span>
                                    </p>
                                </div>
                                {errorGeneralLoteInventario && (
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fas fa-exclamation-circle me-2"></i>
                                        {errorGeneralLoteInventario}
                                    </div>
                                )}
                                {(lote.loteinventarios || []).length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th style={{ width: '20%' }}>Unidades</th>
                                                    <th style={{ width: '40%' }}>Ubicación (Tipo de Inventario)</th>
                                                    <th style={{ width: '25%' }}>Estado</th>
                                                    <th style={{ width: '15%' }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(lote.loteinventarios || []).map((item, inventarioIndex) => {
                                                    const esErrorFila = erroresLoteInventario[`${loteIndex}-${inventarioIndex}`];

                                                    return (
                                                        <tr key={inventarioIndex} className={esErrorFila ? 'table-warning' : ''}>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className={`form-control form-control-sm ${esErrorFila ? "is-invalid" : ""}`}
                                                                    min="0"
                                                                    value={item.existencia}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "existencia", e.target.value)}
                                                                />
                                                                {esErrorFila && (
                                                                    <div className="invalid-feedback">
                                                                        Revise existencia.
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className={`form-control form-control-sm ${esErrorFila ? "is-invalid" : ""}`}
                                                                    value={item.inventarioTipoId}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "inventarioTipoId", e.target.value)}
                                                                >
                                                                    <option value="">Seleccione tipo</option>
                                                                    {listaInventariosTipos?.map((tipo) => (
                                                                        <option key={tipo.id} value={tipo.id}>
                                                                            {tipo.nombre}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {esErrorFila && (
                                                                    <div className="invalid-feedback">Debe seleccionar un tipo.</div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className="form-control form-control-sm"
                                                                    value={item.estado}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "estado", e.target.value)}
                                                                >
                                                                    <option value="Activo">Activo</option>
                                                                    <option value="Inactivo">Inactivo</option>
                                                                </select>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light text-danger"
                                                                    onClick={() => eliminarLoteInventario(loteIndex, inventarioIndex)}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-light border text-muted">
                                        <i className="fas fa-map-marker-alt me-2"></i>
                                        Asigne unidades del lote a ubicaciones específicas de inventario.
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Card>
        </Page>
    );
};

export default EditarProducto;